<!-- 搜索结果 - 音频结果 -->

<template>
	<div class="audio-wrap clearFloat">
		<!-- single audio box -->
        <div class="singleAudioBox clearFloat" :data-id="audio.audioID" v-for="(audio,index) in results.data">
        	<span @click="openPage(audio.webUrl)"class="audioTitleInfo clearFloat">
        		<span class="audioTitle">【<b v-html="audio.webTitleFormat"></b>】</span>
        		<span class="audioSubTitle">&nbsp;{{audio.singer}}</span>
        	</span>
        	<!--<p class="audioIntroduce" v-html="audio.webContentFormat"></p>-->
        	<span @click="openPage(audio.webUrl)" class="audioUrl">{{audio.webUrl}}</span>
          <a class="audioIsSave saveBtn" v-if="!audio.hasAction">{{audio.statusDesc}}</a>
          <a class="audioNotSave saveBtn" v-if="audio.hasAction" @click="saveEvidence(index)">存证</a>
	    </div>
	</div>
</template>

<script>

  export default {
      name:'audioResults',
      props: ['results'],
      mounted(){
//        this.init();
      },
      data () {
          return {

          }
      },
      methods: {
          getID (audioID) {
          },
          saveEvidence(id){
              this.$emit('savingEvidence', id);
          },
//          init(){
//            let path = this.$router.currentRoute.path;
//            let keyword = typeof this.$router.currentRoute.query.keyword == 'undefined' ? '' : decodeURIComponent(this.$router.currentRoute.query.keyword);
//            this.$emit('changeChild', path.substring(path.lastIndexOf('/')+1), keyword);
//          },
          openPage(url){
            window.open(url);
          }
      },
      watch: {
        '$route' (to, from) {
          //刷新参数放到这里里面去触发就可以刷新相同界面了
//          this.init();
        }
      }

  }
</script>

<style scoped>
	/* reset style */
	p{
		margin:0;
		padding:0;
	}
	a{
		text-decoration: none;
		color: #000;
	}
	/* clear float style */
    .clearFloat:after{
    	content: '.';
    	height: 0;
    	overflow: hidden;
    	clear: both;
    	visibility: hidden;
    	display: block;
    	cursor: pointer;
    }
	/* audio results style */
	.singleAudioBox{
		/*height: 106px;*/
		position: relative;
		/*margin-bottom: 15px;*/
    margin-bottom: 32px;
	}
	.audioTitleInfo{
		font-size: 18px;
    cursor:pointer;
	}
	.audioTitleInfo .audioTitle{
		float: left;
	}
	.audioTitleInfo .audioSubTitle{
		float: left;
		width: 340px;
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap;
	}
	.audioTitleInfo .audioTitle b{
		/*color: #d0021b;*/
		font-weight: normal;
	}
	.audioIntroduce{
		float: left;
		width: 99%;
		font-size: 14px;
		padding-left: 8px;
		margin: 13px 0 10px;
    word-break: break-all;
	}
	.audioUrl{
		float: left;
		font-size: 14px;
		color: #417505;
		padding-left: 8px;
    width: 60%;
    box-sizing: border-box;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    cursor: pointer;

    margin-top:12px;
	}
	.saveBtn{
		position: absolute;
		right: 0;
		bottom: 0;
		width: 52px;
		height: 30px;
		text-align: center;
		line-height: 30px;
		color: #fff;
		background-color:  #A12935;
		font-size: 14px;
		border-radius: 3px;
    cursor: pointer;
	}
  .audioNotSave:hover{
    background-color:  #c11c27;
  }
	.audioIsSave{
		background-color: #a0a0a0;
    cursor: not-allowed;
	}


</style>



// WEBPACK FOOTER //
// AudioResults.vue?44c150bf